export default __webpack_public_path__ + "static/media/element_spec_22.13c7d89f.webp";